import { Linkedin } from "lucide-react";

export default function LeaderCard({ member }) {
  return (
    <div
      className="
        flex
        w-full
        max-w-[380px]
        overflow-hidden
        rounded-[15px]
        border
        border-white/10
        bg-[#0B1322]
      "
    >
      {/* Photo column */}
      <div className="w-[145px] shrink-0">
        <img
          src={member.image}
          alt={member.name}
          className="h-full w-full object-cover object-top"
        />
      </div>

      {/* Content column */}
      <div className="flex flex-1 flex-col justify-center pl-3 pr-2 py-2">
        <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#21A6E9]">
          {member.role}
        </p>

        <h3 className="mt-1 text-[16px] font-bold uppercase leading-tight tracking-tight text-white">
          {member.name}
        </h3>

        <div className="mt-2 h-[2px] w-8 rounded-full bg-[#21A6E9]" />

        <p className="mt-1 text-[12px] leading-5 text-slate-400">
          {member.description}
        </p>

        <a
          href={member.linkedin}
          target="_blank"
          rel="noreferrer"
          className="
            mt-3
            flex
            h-6
            w-6
            items-center
            justify-center
            rounded-md
            border
            border-white/10
            bg-white/5
            transition-all
            duration-300
            hover:border-[#21A6E9]
            hover:bg-[#21A6E9]
            hover:text-[#020617]
          "
        >
          <Linkedin size={14} className="text-[#21A6E9]" />
        </a>
      </div>
    </div>
  );
}